class ScrollObserver {
    constructor(callbacks) {
        this.callbacks = callbacks; // { onLoadMore, onActiveChange, onReachedMiddle, onReachedNearEnd }
        this.loaderObserver = null;
        this.activeObserver = null;
        this.triggerObserver = null;
        this.sentinel = null;

        this.init();
    }

    init() {
        // 1. Loader Observer (Bottom) - Keep for backward compatibility or as safety
        this.loaderObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (this.callbacks.onLoadMore) {
                        this.callbacks.onLoadMore('sentinel');
                    }
                }
            });
        }, {
            rootMargin: '600px'
        });

        // 2. Main Observer (Active Element)
        this.activeObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (this.callbacks.onActiveChange) {
                        this.callbacks.onActiveChange(entry.target);
                    }
                }
            });
        }, {
            // Focus on a narrow strip below the header to determine active post
            // -250px from top to ensure we are well into the article content
            rootMargin: '-30% 0px -60% 0px',
            threshold: 0
        });

        // 3. Trigger Observer (Plan/HTML preload triggers)
        this.triggerObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const type = entry.target.getAttribute('data-trigger-type');
                    
                    if (type === 'plan' && this.callbacks.onReachedMiddle) {
                        this.callbacks.onReachedMiddle(entry.target);
                    } else if (type === 'html' && this.callbacks.onReachedNearEnd) {
                        this.callbacks.onReachedNearEnd(entry.target);
                    }
                    
                    // Once triggered, we can stop observing this specific sentinel
                    this.triggerObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -20% 0px' // Trigger when sentinel is near bottom of viewport
        });
    }

    observeSentinel(element) {
        if (this.sentinel) this.loaderObserver.unobserve(this.sentinel);
        this.sentinel = element;
        if (element) this.loaderObserver.observe(element);
    }

    observeItem(element) {
        this.activeObserver.observe(element);
    }

    observeTrigger(element, type = 'plan') {
        element.setAttribute('data-trigger-type', type);
        this.triggerObserver.observe(element);
    }

    // Deprecated but kept for compatibility
    observeMiddle(element) {
        this.observeTrigger(element, 'plan');
    }
}

window.SaborlistaScrollObserver = ScrollObserver;
